import frameQuickRuleImg from '@assets/web-v3-images/FrameQuickRule.png';
import { Text } from '@radix-ui/themes';
import { useTranslation } from 'react-i18next';
import RuleContent from '@/component/RuleContent';

export default function QuickRule({ content, quickRuleRef }) {
	const { t } = useTranslation()

	return (
		<div
			ref={quickRuleRef}
			className="relative w-full aspect-[1080/450] mb-5 mt-4"
			style={{
				backgroundImage: `url(${frameQuickRuleImg})`,
				backgroundRepeat: 'no-repeat',
				backgroundPosition: 'top center',
				backgroundSize: '100% 100%',
			}}
		>
			<Text className="absolute left-1/2 top-[12%] -translate-x-1/2 -translate-y-1/2 text-[27px] font-bold text-[#7A2E0E]">
				{t('shwe_vault.quick_rule')}
			</Text>
			<div
				className="
					absolute
					left-[5%]
					right-[18%]
					top-[60%]
					-translate-y-1/2
					h-[70%]
					flex
					items-center
  			"
			>
				{content ? (
					<RuleContent
						content={content}
						className="w-[75%] max-h-full overflow-y-auto pr-2 hide-scrollbar scrollbar-h-2
										scrollbar-thin
										scrollbar-thumb-[#E6B97D]
										scrollbar-track-transparent
										text-left text-[#542314] text-[23px] font-medium"
					/>
				) : (
					<ul
						className="w-[75%] max-h-full overflow-y-auto pr-2 hide-scrollbar scrollbar-h-2
											scrollbar-thin
											scrollbar-thumb-[#E6B97D]
											scrollbar-track-transparent
											space-y-2"
					>
						<li className="flex items-start gap-2 text-left text-[#542314] text-[23px] font-medium">
							<span className="mt-[0.5em] w-[6px] h-[6px] md:w-[8px] md:h-[8px] rounded-full bg-[#542314] flex-shrink-0" />
							<span>{t("loyalty_point.earn_mytel_loyalty_points_from_login_streak_shwe_vault_daily_rewards")}</span>
						</li>
						<li className="flex items-start gap-2 text-left text-[#542314] text-[23px] font-medium">
							<span className="mt-[0.5em] w-[6px] h-[6px] md:w-[8px] md:h-[8px] rounded-full bg-[#542314] flex-shrink-0" />
							<span>{t("loyalty_point.withdraw_them_to_your_mytel_account_and_use_them_in_the_MyID_app")}</span>
						</li>
					</ul>
				)}
			</div>
		</div>
	);
}